import { z } from "zod";

export const clientEntitySchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, { message: "El nombre debe ser valido" }),
  description: z.string().optional(),
  zones: z.array(z.string()).optional(),
  enabled: z.boolean().default(true),
});
